import axios from 'axios'

function mapStatusToAction(status, isCancel = false) {
  const map = {
    1: 'checkin',
    2: 'in_class',
    3: 'queue',
    4: 'checkout',
  }
  if (isCancel) return 'cancel'
  return map[Number(status)] || null
}

function mapMeta(meta = {}) {
  return {
    total: meta.total || 0,
    current_page: meta.current_page || 1,
    per_page: meta.per_page || (meta.total || 0),
    from: meta.from || 0,
    to: meta.to || 0,
  }
}

export default {
  getIkidClassDashboard(params) {
    axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
    return axios.get('/kid/class_dashboard/ikidclass', { params }).then((response) => response.data)
  },

  transitionStatus(payload) {
    return axios.post('/v2/ikids/status/transition', payload).then((response) => response.data)
  },

  transitionStatusPortal(payload) {
    return axios.post('/v2/portal/ikids/status/transition', payload).then((response) => response.data)
  },

  getKidsClass(params = {}) {
    return axios.get('/v2/ikids/kids-class', { params }).then((response) => response.data)
  },

  getKidQueue(params = {}) {
    return axios.get('/v2/ikids/kidqueue', { params }).then((response) => response.data)
  },

  getKidsCheck(params = {}) {
    return axios.get('/v2/ikids/kids-check', { params }).then((response) => response.data)
  },

  searchCheckinCheckout(params = {}) {
    return axios.get('/v2/ikids/checkin-checkout-search', { params }).then((response) => response.data)
  },

  // adapters for current page contracts
  getIkidClassDataSource(params = {}) {
    return this.getKidsClass(params).then((res) => {
      if (res.not_changed) return res
      if (res.delta) {
        return {
          event_id: res.event_id,
          not_changed: false,
          delta: true,
          changed_items: res.changed_items || [],
          removed_ids: res.removed_ids || [],
        }
      }
      return {
        event_id: res.event_id,
        not_changed: false,
        delta: false,
        data: {
          data: res.items || [],
          ...mapMeta(res.meta),
        },
      }
    })
  },

  getIkidQueue(params = {}) {
    return this.getKidQueue(params).then((res) => {
      if (res.not_changed) return res
      if (res.delta) {
        return {
          event_id: res.event_id,
          not_changed: false,
          delta: true,
          changed_items: res.changed_items || [],
          removed_ids: res.removed_ids || [],
        }
      }
      return {
        event_id: res.event_id,
        not_changed: false,
        delta: false,
        data: res.items || [],
        meta: mapMeta(res.meta),
      }
    })
  },

  getKidsCheckManual(payload = {}) {
    const list = payload.list || {}
    const params = {
      class_id: list.kid_class_id || null,
      status: list.checkin_status || null,
      search: list.search || '',
      limit: list.per_page || 200,
      if_modified_since_event_id: payload.if_modified_since_event_id || null,
      include_summary: payload.include_summary === false ? 0 : 1,
      use_delta: payload.use_delta === false ? 0 : 1,
    }

    return this.getKidsCheck(params).then((res) => {
      if (res.not_changed) return res
      if (res.delta) {
        return {
          event_id: res.event_id,
          not_changed: false,
          delta: true,
          changed_items: res.changed_items || [],
          removed_ids: res.removed_ids || [],
          summary: {
            data: (res.summary || []).map((row) => ({
              id: row.class_id,
              name: row.name || row.class_name,
              count_check_in: row.count_check_in || 0,
              count_queued: row.count_queued || 0,
              count_check_out: row.count_check_out || 0,
              count2_check_in: row.count2_check_in || 0,
              count2_queued: row.count2_queued || 0,
              count2_check_out: row.count2_check_out || 0,
            })),
          },
        }
      }

      return {
        event_id: res.event_id,
        not_changed: false,
        delta: false,
        summary: {
          data: (res.summary || []).map((row) => ({
            id: row.class_id,
            name: row.name || row.class_name,
            count_check_in: row.count_check_in || 0,
            count_queued: row.count_queued || 0,
            count_check_out: row.count_check_out || 0,
            count2_check_in: row.count2_check_in || 0,
            count2_queued: row.count2_queued || 0,
            count2_check_out: row.count2_check_out || 0,
          })),
        },
        list: {
          data: res.items || [],
          ...mapMeta(res.meta),
        },
      }
    })
  },

  changeStatusKid(formdata) {
    return this.transitionStatus({
      kid_id: formdata.ikid_id,
      action: mapStatusToAction(formdata.status),
      source: formdata.from || 'portal',
    })
  },

  changeStatusKidQueue(formdata) {
    return this.changeStatusKid(formdata)
  },

  cancelStatusKid(formdata) {
    return this.transitionStatus({
      kid_id: formdata.ikid_id,
      action: 'cancel',
      source: formdata.from || 'portal',
    })
  },

  changeStatusKidPortal(formdata) {
    return this.transitionStatusPortal({
      kid_id: formdata.ikid_id,
      action: mapStatusToAction(formdata.status),
      source: formdata.from || 'portal',
      source_channel: formdata.source_channel || null,
    })
  },

  cancelStatusKidPortal(formdata) {
    return this.transitionStatusPortal({
      kid_id: formdata.ikid_id,
      action: 'cancel',
      source: formdata.from || 'portal',
      source_channel: formdata.source_channel || null,
    })
  },

  cancelStatusKidQueue(formdata) {
    return this.cancelStatusKid(formdata)
  },

  getIkidbyID(id) {
    return axios.get('/kid/' + id).then((response) => response.data)
  },
}
